/* eslint complexity: ["error", 5], max-params: ["error", 4], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';
var deferreds = [];

function url(name) {
    return Odigeo.Utils.getImageFromCDN('onefront/bluestone/icons/spot/' + name + '.svg');
}

function getSvgImages(sgvObject, cbError, cbSuccess, cbAllSuccess) {
    Odigeo._.forEach(sgvObject, function(value, key) {
        getSvgImage.call(this, key, cbError, cbSuccess);
    });
    $.when.apply($, deferreds).then(function() {
        cbAllSuccess();
        deferreds.length = 0;
    }, cbError);
}

function getSvgImage(name, cbError, cbSuccess) {
    // eslint-disable-next-line no-restricted-properties
    var deferred = $.ajax({
        url: url.call(this, name),
        method: 'GET',
        dataType: 'xml',
        success: function(data) {
            cbSuccess(data, name);
        },
        error: cbError,
        timeout: 1000,
    });
    deferreds.push(deferred);
}

module.exports = {
    getSvgImages: getSvgImages,
    getSvgImage: getSvgImage,
};
